'use client';
import Button from './Button';

type Props = {
  site: string;
};

const ShowMoreToggle: FC<Props> = ({ children, site }) => {
  const handleToggle = () => {
    document.getElementById('collapsed-container')?.classList.toggle('open');
  };
  return (
    <Button
      className="font-normal"
      variant="tertiary"
      onClick={handleToggle}
      site={site}
    >
      {children}
    </Button>
  );
};

export default ShowMoreToggle;
